// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".x-Wizard-errorMessage {\n  color: lightgoldenrodyellow;\n  white-space: pre-line;\n}\n.x-Wizard-errorCode {\n  font-size: 9px;\n  font-style: italic;\n}\n", "",{"version":3,"sources":["webpack://./web/app/cad/craft/wizard/components/Wizard.less"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,qBAAA;AACF;AAEA;EACE,cAAA;EACA,kBAAA;AAAF","sourcesContent":[".errorMessage {\n  color: lightgoldenrodyellow;\n  white-space: pre-line;\n}\n\n.errorCode {\n  font-size: 9px;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "x-Wizard-errorMessage",
	"errorCode": "x-Wizard-errorCode"
};
export default ___CSS_LOADER_EXPORT___;
